<template lang="html">
  <div class="draft-review">
    <header>
      <div>
        <router-link class="back" :to="`/draft/${id}/settings`">
          <i class="fas fa-arrow-left"></i>
          <img src="../assets/images/logo.png" width="80">
        </router-link>
      </div>

      <div class="title">
        Draft Results
      </div>

      <div class="button-group">
        <button v-if="isAuthenticated" @click="slideshow">Slideshow</button>
        <button v-if="isAuthenticated" @click="viewHistory">History</button>
        <router-link v-if="!isAuthenticated" class="button" to="/dashboard">
          Try your own for free
        </router-link>
      </div>
    </header>

    <div class="teams">
      <section
        class="card-container"
        v-for="(team, i) in draftRosters"
        :key="i"
      >
        <div class="team card" @click="viewTeam(team)">
          <h4>{{ team.name }}</h4>

          <div
            class="player"
            v-for="pick in team.picks"
            :key="pick.pick"
          >
            <div class="round">{{ pick.pick }}</div>
            <div class="name">
              {{ `${pick.position} ${pick.name}, ${pick.team}` }}
              <span class="keeper-status" v-if="pick.keeper">K</span>
            </div>
          </div>
        </div>
      </section>
    </div>

    <draft-review-team-modal ref="teamModal" :team="activeTeam" />
    <draft-review-history-modal ref="historyModal" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import DraftReviewTeamModal from './DraftReviewTeamModal';
import DraftReviewHistoryModal from './DraftReviewHistoryModal';

export default {
  components: {
    DraftReviewTeamModal,
    DraftReviewHistoryModal,
  },

  data() {
    return {
      activeTeam: null,
      slideshowTimeout: 10000,
    };
  },

  computed: {
    ...mapState({
      id: ({ route }) => route.params.id,
      startSlideshow: ({ route }) => route.query.startSlideshow,
      teamQuery: ({ route }) => route.query.team,
    }),

    ...mapGetters({
      draftRosters: 'draft/draftRosters',
      isAuthenticated: 'auth/isAuthenticated',
    }),
  },

  mounted() {
    if (this.startSlideshow) {
      this.slideshow();
    } else if (this.teamQuery) {
      const team = this.draftRosters.find(({ id }) => id === parseInt(this.teamQuery, 10));

      if (team) {
        this.viewTeam(team);
      }
    }
  },

  methods: {
    viewTeam(team) {
      this.$refs.teamModal.open();
      this.activeTeam = team;
    },

    viewHistory() {
      this.$refs.historyModal.open();
    },

    slideshow() {
      this.$refs.teamModal.open();

      let i = 0;

      this.activeTeam = this.draftRosters[i];

      const interval = setInterval(() => {
        i += 1;

        if (i === this.draftRosters.length) {
          clearInterval(interval);
          this.$refs.teamModal.close();
        } else {
          this.activeTeam = this.draftRosters[i];
        }
      }, this.slideshowTimeout);
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .draft-review {
    background-color: $dark-color;
    padding: $gp;
    min-height: 100vh;
  }

  header {
    display: flex;
    justify-content: space-between;
    margin-bottom: $gp * 2;
    align-items: center;

    .title {
      color: $white-color;
      font-size: px-to-rem(24px);

      @media($small) {
        display: none;
      }
    }
  }

  .back img {
    margin-left: $gp / 2;
  }

  .teams {
    @include cardLayout(20%);
  }

  .team {
    cursor: pointer;

    h4 {
      margin: 0 0 $gp;
    }
  }

  .player {
    margin-bottom: $gp;
    display: flex;
    align-items: center;

    .round {
      font-weight: $font-weight-bold;
      width: px-to-rem(20px);
      margin-right: $gp;
    }
  }
</style>
